module.exports = __webpack_public_path__ + "media/images/JTRSforstudents-5a6a1f32c27ec6f51eba6738240f3ca2.png";